"use strict";const e=require("./index42.js"),o=require("./index271.js");var i=e.defineBuiltIn,r=o.errorToString,t=Error.prototype;t.toString!==r&&i(t,"toString",r);
